// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8252 ? "793471a0" : chunkId) + "." + {"211":"22a25aaba6ee82df","7929":"348341ff53395298","8252":"85500d73230cfea6","9415":"8528f3fd14b4f01b"}[chunkId] + ".js";
};